import type { ChatSettingsResponseModel } from '@/shared/generated'
import type { UseQueryOptions } from '@tanstack/react-query'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export function useAssistantChatSettingsQuery<T = ChatSettingsResponseModel>(
	options?: UseQueryOptions<ChatSettingsResponseModel, Error, T>
) {
	return useQuery<ChatSettingsResponseModel, Error, T>({
		queryKey: ['ai-chat', 'settings'],
		queryFn: () => client.assistant.assistantChatSettingsGet(),
		...(options || {}),
	})
}
